import React from 'react';
import MailIcon from '@mui/icons-material/MailOutline';
import EventIcon from '@mui/icons-material/Event';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventIcon: {
    position: 'absolute',
    bottom: '0',
    right: '0',
    fontSize: '0.5rem',
  },
}));

export const SchedulingIcon = ({ className }: { className?: string }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <MailIcon
        fontSize="small"
        className={className}
        sx={!className ? { fontSize: 15, lineHeight: 15 } : {}}
      />
      <EventIcon className={classes.eventIcon} sx={{ bgcolor: 'white' }} />
    </div>
  );
};
